/* Moolee cart conversion optimisations - 20 Aug 2026 */
(function () {
  function formatMoney(pence) {
    var amount = Number(pence || 0) / 100;

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(amount);
    } catch (error) {
      return '£' + amount.toFixed(2);
    }
  }

  function cartCountText(count) {
    return count + (count === 1 ? ' item' : ' items');
  }

  function initMooleeCart() {
    var stickyBar = document.querySelector('[data-moolee-cart-sticky]');
    var mainCheckout = document.querySelector('.moolee-cart-main-checkout');
    var stickyTotal = document.querySelector('[data-moolee-cart-sticky-total]');
    var pageCount = document.querySelector('[data-moolee-cart-count]');
    var summaryCount = document.querySelector('[data-moolee-cart-summary-count]');
    var cartHasItems = true;
    var checkoutVisible = true;

    function setStickyState() {
      if (!stickyBar) return;
      stickyBar.classList.toggle('is-visible', cartHasItems && !checkoutVisible);
    }

    if (stickyBar && mainCheckout) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries.length) return;
          checkoutVisible = entries[0].isIntersecting;
          setStickyState();
        }, {
          threshold: 0.18
        });

        observer.observe(mainCheckout);
      } else {
        checkoutVisible = false;
        setStickyState();
      }
    }

    document.addEventListener('cart:updated', function (event) {
      if (!event.detail || !event.detail.cart) return;

      var cart = event.detail.cart;
      var count = Number(cart.item_count || 0);
      var totalText = formatMoney(cart.total_price);

      cartHasItems = count > 0;

      if (stickyTotal) {
        stickyTotal.textContent = totalText;
      }

      if (pageCount) {
        pageCount.textContent = cartCountText(count) + ' in your basket';
      }

      if (summaryCount) {
        summaryCount.textContent = cartCountText(count);
      }

      setStickyState();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMooleeCart);
  } else {
    initMooleeCart();
  }
})();
